/**
 * ROC 7
 * Copyright 2017 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */
define('modules/Delivery/PriceAndDeliveryOptionsService',[
    'jquery',
    'global/all'
], function ($, Roc) {
    'use strict';

    function getDeliveryOptionsForSingleItem(productId, orderItemId, unitOfMeasure) {
        var request = {
            productId: productId,
            orderId: '{orderId}',
            userId: '{userId}',
            unitOfMeasure: unitOfMeasure
        };

        if (orderItemId) {
            request.orderItemId = orderItemId;
        }

        return $.proxyRequest({
            url: '/api/productdelivery/options',
            data: JSON.stringify(request),
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            complete: function (xhr) {
                Roc.Logger.info('DeliveryOptionsService -> getDeliveryOptionsForSingleItem');
                Roc.Logger.info(xhr);
            }
        });
    }

    function getDeliveryOptionsForMultipleProducts(productSkus) {
        if (_.some(productSkus, function (value) { return value === undefined || value === null })) {
            return false;
        }

        var request = {
            skus: productSkus,
            orderId: '{orderId}',
            userId: '{userId}'
        }
        
        return $.proxyRequest({
            url: '/api/productdelivery/options/multiple',
            data: JSON.stringify(request),
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            complete: function (xhr) {
                Roc.Logger.info('DeliveryOptionsService -> getDeliveryOptionsForMultipleProducts');
                Roc.Logger.info(xhr);
            }
        });
    }

    function getDeliveryOptionsForCart(cart) {
        var request = {
            orderId: '{orderId}',
            userId: '{userId}'
        }

        addExpressShipToLocation(request);
        return $.proxyRequest({
            url: '/api/productdelivery/options/cart',
            data: JSON.stringify(request),
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            complete: function (xhr) {
                Roc.Logger.info('DeliveryOptionsService -> getDeliveryOptionsForCart');
                Roc.Logger.info(xhr);
                Roc.UI.unblock();
            }
        });
    }

    function getWarehousesInRegion(callback) {
        var request = {};

        addExpressShipToLocation(request);
        return $.proxyRequest({
            url: 'api/warehousegroup/warehousesinregion',
            data: JSON.stringify(request),
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            complete: function (xhr) {
                Roc.Logger.info('DeliveryOptionsService -> getWarehousesInRegion');
                Roc.Logger.info(xhr);
                callback(xhr);
            }
        });
    }
    
    var PriceAndDeliveryOptionsService = {
        getDeliveryOptionsForSingleItem: getDeliveryOptionsForSingleItem,
        getDeliveryOptionsForMultipleProducts: getDeliveryOptionsForMultipleProducts,
        getDeliveryOptionsForCart: getDeliveryOptionsForCart,
        getWarehousesInRegion: getWarehousesInRegion
    };

    Roc.Logger.debug('PriceAndDeliveryOptionsService.js Loaded:', PriceAndDeliveryOptionsService);

    return PriceAndDeliveryOptionsService;

});
